import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../../siteSettings';
import './style.css';

const MobileMenu = () => {
    const settings = useSiteSettings();
    const [isMenuShow, setIsMenuShow] = React.useState(false);
    const [activeLink, setActiveLink] = React.useState('home');
    const sectionIsVisible = (id) => {
        const layout = settings.sectionLayout;
        if (!layout || !layout.length) return true;
        const section = layout.find((item) => item.id === id);
        return !section || section.visible !== false;
    };
    const sectionHasContent = (id) => id !== 'gallery' || Boolean(
        settings.gallerySection &&
        Array.isArray(settings.gallerySection.items) &&
        settings.gallerySection.items.some((item) => item && item.image)
    );

    const activate = (link) => () => {
        setActiveLink(link);
        setIsMenuShow(false);
        if (link === 'home') window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                <div className="logo2">
                    <h2><Link to='/'>{settings.coupleNames}</Link></h2>
                </div>
                <ul className="responsivemenu">
                    {sectionIsVisible('hero') && <li><Link className={activeLink === 'home' ? 'active' : ''} onClick={activate('home')} to='/'>Accueil</Link></li>}
                    {sectionIsVisible('couple') && <li><AnchorLink className={activeLink === 'couple' ? 'active' : ''} onClick={activate('couple')} href='#couple'>Les mariés</AnchorLink></li>}
                    {sectionIsVisible('story') && <li><AnchorLink className={activeLink === 'story' ? 'active' : ''} onClick={activate('story')} href='#story'>Notre histoire</AnchorLink></li>}
                    {sectionIsVisible('event') && <li><AnchorLink className={activeLink === 'event' ? 'active' : ''} onClick={activate('event')} href='#event'>Événements</AnchorLink></li>}
                    {sectionIsVisible('gallery') && sectionHasContent('gallery') && <li><AnchorLink className={activeLink === 'gallery' ? 'active' : ''} onClick={activate('gallery')} href='#gallery'>Galerie</AnchorLink></li>}
                    {sectionIsVisible('rsvp') && <li><AnchorLink className={activeLink === 'rsvp' ? 'active' : ''} onClick={activate('rsvp')} href='#rsvp'>RSVP</AnchorLink></li>}
                </ul>
            </div>

            {isMenuShow && <div className="mobileMenu-overlay" onClick={() => setIsMenuShow(false)} aria-hidden="true" />}

            <div className="showmenu" onClick={() => setIsMenuShow(!isMenuShow)}><i className="fa fa-bars" aria-hidden="true"></i></div>
        </div>
    );
};

export default MobileMenu;
